import {Pagination} from '@app/core/models/pagination.model';
import {ShiftDraft} from '@app/core/models/ShiftDraft.model';

export interface IShiftDraftsState {
	pagination: Pagination;
	shiftDrafts: ShiftDraft[];
	selectedShiftDraft: ShiftDraft;
	isLoading: boolean;
	isReleasingDraft: boolean;
}

export const initialShiftDraftsState: IShiftDraftsState = {
	shiftDrafts: [],
	selectedShiftDraft: null,
	pagination: null,
	isLoading: false,
	isReleasingDraft: false,
};
